import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';

import { ParameterResult } from '@models/swagger';
import { ApiService, DefaultHttpHeaders } from '@services/api/api.service';

export interface FloorNumberParams extends DefaultHttpHeaders {
  /** Unique identifier of floor number */
  floorNumberCode: string;
}

@Injectable()
export class FloorNumberService extends ApiService {
  constructor(protected readonly injector: Injector) {
    super(injector);
  }

  /**
   * Service for obtaining floor number by code
   * Service for obtaining floor number by code
   * https://d2go64w4712gob.cloudfront.net/swagger/apis_trasversales/italia/api_Verti.html#/Catalog/getComeroundFloorNumberById
   */
  floorNumber(params: FloorNumberParams): Observable<ParameterResult> {
    const pathParams = {
      floorNumberCode: params.floorNumberCode,
    };
    return this.get<ParameterResult>({
      suffix: `/comeround/catalog/floorNumber/${pathParams.floorNumberCode}`,
    });
  }
}
